<h4><p class="text-center">Agenda</p></h4>

<div class="row ui-toolbar">
  <div class="col-12">
    <button type="button" class="btn btn-outline-primary pull-right" (click)="displayNew = true">
      Nieuwe afspraak
    </button>
  </div>
</div>

<p-dialog header="Nieuwe afspraak" [width]="600" [(visible)]="displayNew">
  <pre class="alert alert-danger" *ngIf="newError">{{newError}}</pre>
  <div class="form-group row">
    <label class="col-form-label col-3">Omschrijving</label>
    <div class="col-9"><input class="form-control" [(ngModel)]="newTitle" type="text"></div>
  </div>
  <div class="form-group row">
    <label class="col-form-label col-3">Datum</label>
    <div class="col-9">
      <p-calendar [(ngModel)]="newDate" dateFormat="dd-mm-yy"></p-calendar>
    </div>
  </div>

  <div class="form-group row">
    <label class="col-form-label col-3">Klant</label>
    <div class="col-9"><p-dropdown [options]="customerList" [(ngModel)]="newCustomer"></p-dropdown></div>
  </div>

  <p-footer>
    <button type="button" class="btn btn-primary" (click)="saveNewApointment()">
      Opslaan
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="displayNew = false">
      Annuleren
    </button>
  </p-footer>
</p-dialog>

<p-dialog header="Afspraak" [width]="600" [(visible)]="display">
  <ng-container *ngIf="selectedApointment">
    <div class="form-group row">
      <label class="col-form-label col-3">Omschrijving</label>
      <div class="col-9"><input class="form-control" [(ngModel)]="selectedApointment.title" type="text"></div>
    </div>
    <div class="form-group row">
      <label class="col-form-label col-3">Datum</label>
      <div class="col-9">
        <p-calendar [(ngModel)]="selectedDate" dateFormat="dd-mm-yy"></p-calendar>
      </div>
    </div>
    <h4>Klant informatie</h4>
    <div class="row">
      <div class="col-5">
        <strong>Straat</strong>
      </div>
      <div class="col-7">
        {{selectedApointment.customer.street}}
      </div>
    </div>
    <div class="row">
      <div class="col-5">
        <strong>Postcode</strong>
      </div>
      <div class="col-7">
        {{selectedApointment.customer.postal}}
      </div>
    </div>
    <div class="row">
      <div class="col-5">
        <strong>Plaats</strong>
      </div>
      <div class="col-7">
        {{selectedApointment.customer.city}}
      </div>
    </div>
    <div class="row">
      <div class="col-5">
        <strong>Telefoon</strong>
      </div>
      <div class="col-7">
        {{selectedApointment.customer.phonenumber}}
      </div>
    </div>
    <div class="row">
      <div class="col-5">
        <strong>Contactpersoon</strong>
      </div>
      <div class="col-7">
        {{selectedApointment.customer.contact}}
      </div>
    </div>
    <div class="row">
      <div class="col-5">
        <strong>Telefoon contactpersoon</strong>
      </div>
      <div class="col-7">
        {{selectedApointment.customer.contactPhone}}
      </div>
    </div>
  </ng-container>
  <p-footer>
    <button type="button" class="btn btn-primary" (click)="saveApointment()">
      Opslaan
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="display = false">
      Annuleren
    </button>
    <button type="button" class="btn btn-outline-danger" (click)="deleteApointment()">
      Verwijder
    </button>
  </p-footer>
</p-dialog>

<div class="card">
  <div class="card-block">
    <p-schedule
      [events]="events" (onViewRender)="loadEvents($event)" [editable]="true"
      (onEventClick)="eventClick($event)" (onEventDrop)="eventDrop($event)"
      [options]="config" [height]="tableHeight"></p-schedule>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/pages/agenda/agenda.component.html